type AuthLayoutProps = React.PropsWithChildren

export const AuthLayout = ({ children }: AuthLayoutProps) => (
  <div className="flex min-h-screen bg-sky-500">
    <main className="flex flex-1 overflow-y-auto">{children}</main>
  </div>
)
